import { useState } from "react"
import { HexMap } from "../../Data/HexMap/HexMap"
import { Note } from "../../Data/HexMap/Note"
import { Music } from "../../Util/Music/Music"
import { TransformTranslate } from "../../Util/Transform/Transform"
import { HxMapGroup } from "../HxMap/HxMapGroup"
import { BuildHexMap } from "../../Data/HexMap/HexMapBuilder"
import { ChordShape } from "../ChordShapes/ChordShape"
import './ChordShapeHelper.scss'

export function ChordShapeHelper(props:{onTitleClick?:Function, offset?:number, onNoteClick?:Function, width?:number, height?:number, radius?:number, hidePositions?:boolean, hideShape?:boolean, showCaption?:boolean}){
    const tonic:number = Music.G
    const radius:number = (props.radius) ? props.radius : 50
    const height:number = (props.height) ? props.height : radius * 2.8
    const width:number = (props.width) ? props.width : radius * 2.8
    const formula:number[] = [0,2,4]
    const getInitialSelectedIndex = () => {
        if(props.offset !== undefined){
            return props.offset
        }
        return 0
    }
    const getSelectedIndex = () => {
        if(props.offset !== undefined){
            return props.offset
        }
        return selectedIndex
    }
    const [selectedIndex, setSelectedIndex] = useState<number>(getInitialSelectedIndex())
    const getMap = () => {
        let mapData:HexMap = BuildHexMap({columns:1, rows:1, tonic:tonic, radius:radius})
        mapData.notes.forEach((note:Note)=>{
            note.defined = false
        })
        const selIndex:number = getSelectedIndex()
        formula.forEach((formulaIndex:number)=>{
            const i:number = (selIndex + formulaIndex + 7) % 7
            const state:number = (formulaIndex === 0) ? Note.SelectedState_Hilited: Note.SelectedState_Selected
            const note:Note = mapData.notes[i]
            note.selectedState = state
            note.primaryLabel =  (!props.hidePositions) ? String( (formulaIndex + 1) % 7 ) : ''
            if(formulaIndex === 0){
                note.primaryLabel = 'Root'
            }
            note.defined = (props.hidePositions) ? false : true
        })
        return mapData
    }
    const onRootSelect = (note:Note) => {
        setSelectedIndex(note.params.noteIndex)
        if(props.onNoteClick){
            props.onNoteClick(note.params.noteIndex)
        }
    } 
    const onTitleClick = () => {
        if(props.onTitleClick){props.onTitleClick(getSelectedIndex())}
    }
    return(
        <div className={'chord-shape-helper-container'}>
            <svg width={width} height={height} className={'chord-shape-helper'}>
                <g transform={TransformTranslate(width/2,height/2)}>
                    <HxMapGroup onNoteClick={onRootSelect} hexMap={getMap()}>
                        {!props.hideShape && <ChordShape root={getSelectedIndex()} formula={formula} notes={getMap().notes} parentKey={getMap().keys[0][0]}/>}
                    </HxMapGroup>
                </g>
            </svg>
            <div className={'chord-title'}>
                {props.showCaption && <h3 onClick={onTitleClick}>The {getSelectedIndex() + 1} Chord</h3>}
            </div>
        </div>
    )
}

